import Vue from "vue";
import Vuex from "vuex";
import ui from "./ui";
import user from "./user";
import cart from "./cart";
import annotation from "./annotation";
import settings from "./settings";
import history from "./history";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    [ui.name]: ui,
    [user.name]: user,
    [cart.name]: cart,
    [annotation.name]: annotation,
    [settings.name]: settings,
    [history.name]: history
  }
});
